var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast"}},[(_vm.toast.show)?_c('div',{staticClass:"toast"},[_vm._v(" "+_vm._s(_vm.toast.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }